import React from 'react';

function ThemeToggle({ isDark, onToggle }) {
  return (
    <button 
      className={`theme-toggle ${isDark ? 'dark' : ''}`}
      onClick={onToggle}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <span className="toggle-icon">
        <i className="fas fa-moon"></i>
      </span>
      <span className="toggle-icon sun">
        <i className="fas fa-sun"></i>
      </span>
      <span className="toggle-thumb"></span>
    </button>
  );
}

export default ThemeToggle;

